/*
 * @Author: Hank 
 * @Date: 2024-09-18 17:53:12 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-14 09:32:11
 */

<template>
  <div class="new-advertiser">
    <div class="bread-crumb">
      Advertisers<span
        class="current"
      >{{ id ? 'Edit' : 'New' }} Advertiser</span>
    </div>
    <h2>{{ id ? 'Edit' : 'New' }} Advertiser</h2>
    <div class="content">
      <a-steps
        style="width: 400px;margin: 30px auto;margin-bottom: 50px;"
        :current="0"
        :items="[
          {
            title: 'Advertiser',
            description,
          },
          {
            title: 'Affiliate',
            description,
          },
        ]"
        @change="() => {id && router.replace(`/affiliate/edit/${id}`)}"
      />
      <a-form
        ref="formRef"
        :model="formState"
        name="form"
        :label-col="{ span: 4, offset: 1 }"
        :rules="rules"
        @finish="onFinish"
      >
        <a-form-item label="Advertiser ID">
          <span>{{ id ? id : '-' }}</span>
        </a-form-item>
        <a-form-item
          label="Display Status"
          name="displayStatus"
        >
          <a-radio-group
            v-model:value="formState.displayStatus"
            name="radioGroup"
          >
            <a-radio value="active">
              Active
            </a-radio>
            <a-radio value="inactive">
              Inactive
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="Featured Merchants"
          name="featuredMerchants"
        >
          <a-radio-group
            v-model:value="formState.featuredMerchants"
            name="radioGroup"
          >
            <a-radio :value="true">
              Yes
            </a-radio>
            <a-radio :value="false">
              No
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="Logo"
          name="logo"
          :rules="[{ required: formState.featuredMerchants , message: 'Please upload logo', trigger: 'change' }]"
        >
          <div class="logo-uploader">
            <div :class="'logo-placeholder' + (formState.logo ? ' uploaded' : '')">
              <img
                v-if="formState.logo"
                class="avatar"
                :src="formState.logo"
                alt="avatar"
              >
              <loading-outlined v-if="loading" />
            </div>
            <div class="upload-methods">
              <a-upload
                v-model:file-list="fileList"
                name="file"
                method="put"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :custom-request="uploadImg"
                :before-upload="beforeUpload"
                @change="handleChange"
              >
                Choose File
              </a-upload>
              <a
                href="javascript:;"
                @click="showUrlPasteModal = true"
              >Paste Image URL</a>
            </div>
          </div>
          <span class="subtitle">Suggested image size 400px * 400px</span>
        </a-form-item>
        <a-form-item
          label="Advertiser name"
          name="advertiserName"
          :rules="[{ required: true, message: 'Please input advertiser name', trigger: 'change' }]"
        >
          <template #extra>
            <p class="subtitle">
              <ExclamationCircleOutlined style="margin-right: 5px;" />The Name must be the same as that of the Affiliate network
            </p>
          </template>
          <a-input
            v-model:value="formState.advertiserName"
            class="max-w"
            placeholder="Please enter"
          />
        </a-form-item>
        <a-form-item
          label="Advertiser Region"
          name="regionId"
        >
          <a-select
            v-model:value="formState.regionId"
            class="max-w"
            placeholder="Select"
            :options="regionList"
          />
        </a-form-item>
        <a-form-item
          label="Category"
          name="categoryId"
        >
          <a-select
            v-model:value="formState.categoryId"
            class="max-w"
            placeholder="Select"
            :options="categoryList"
          />
        </a-form-item>
        <a-form-item
          label="Assigned AM"
          name="assignedAmId"
        >
          <a-select
            v-model:value="formState.assignedAmId"
            class="max-w"
            placeholder="Select"
            :options="assignedAmImList"
          />
        </a-form-item>
        <a-form-item
          label="Domain"
          name="domain"
        >
          <template #extra>
            <p class="subtitle">
              <ExclamationCircleOutlined style="margin-right: 5px;" />Do not include “Https://www” or “Http://www” and “path”<br>
              Eg: “Https//: www.Lancome.com/uk” you just need to enter “Lancome.com”
            </p>
          </template>
          <a-input
            v-model:value="formState.domain"
            class="max-w"
            placeholder="Please enter"
          />
        </a-form-item>
        <a-form-item
          label="Path"
          name="path"
        >
          <a-input
            v-model:value="formState.path"
            class="max-w"
            placeholder="Please enter"
          />
        </a-form-item>
        <a-form-item
          label="Assigned IM"
          name="assignedImId"
        >
          <a-select
            v-model:value="formState.assignedImId"
            class="max-w"
            placeholder="Select"
            :options="assignedAmImList"
          />
        </a-form-item>
        <a-form-item
          label="KOL rule"
          name="kolRule"
        >
          <a-radio-group
            v-model:value="formState.kolRule"
            name="radioGroup"
            @change="onKolRuleChange"
          >
            <a-radio :value="true">
              Yes
            </a-radio>
            <a-radio :value="false">
              No
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.kolRule"
          label="RuleMode"
          name="kolRuleMode"
          :rules="ruleModeRules"
        >
          <a-radio-group
            v-model:value="formState.kolRuleMode"
            name="kolRuleMode"
            @change="onRuleModeChange"
          >
            <a-radio value="whitelist">
              WhiteList
            </a-radio>
            <a-radio value="blacklist">
              BlackList
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.kolRule && formState.kolRuleMode"
          :name="formState.kolRuleMode === 'blacklist' ? 'kolBlackListIds' : 'kolWhiteListIds'"
          label="RuleList"
          :rules="ruleListRules"
        >
          <a-select
            v-model:value="currentKolListIds"
            mode="multiple"
            label-in-value
            placeholder="Please enter"
            style="width: 400px"
            :filter-option="false"
            :not-found-content="kol.fetching ? undefined : null"
            :options="kol.data"
            :get-popup-container="(triggerNode) => triggerNode.parentNode"
            @search="searchKolWhiteList"
          >
            <template
              v-if="kol.fetching"
              #notFoundContent
            >
              <a-spin size="small" />
            </template>
          </a-select>
        </a-form-item>

        <a-form-item
          label="Merchant Threshold"
          name="merchantThreshold"
        >
          <a-radio-group
            v-model:value="formState.merchantThreshold"
            name="merchantThreshold"
            @change="onMerchantThresholdChange"
          >
            <a-radio :value="true">
              Yes
            </a-radio>
            <a-radio :value="false">
              No
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.merchantThreshold"
          label="Monthly Limit"
          name="monthlyLimit"
          :wrapper-col="{ span: 12 }"
          :rules="merchantMonthlyLimitRules"
        >
          <template #extra>
            <p class="subtitle">
              <ExclamationCircleOutlined style="margin-right: 5px;" />This limit is triggered collectively by total sales from all influencers using this afhliate's link.
            </p>
          </template>
          <a-input-number
            v-model:value="formState.monthlyLimit"
            class="threshold-limit-input"
            :min="1"
            :precision="0"
            :step="1"
            addon-after="$"
            placeholder="Please enter"
            @change="onMerchantMonthlyLimitChange"
          />
        </a-form-item>
        <a-form-item
          v-if="formState.merchantThreshold"
          label="Daily Limit"
          name="dailyLimit"
          :wrapper-col="{ span: 12 }"
          :rules="merchantDailyLimitRules"
        >
          <template #extra>
            <p class="subtitle">
              <ExclamationCircleOutlined style="margin-right: 5px;" />This limit is triggered collectively by total sales from all influencers using this afhliate's link.
            </p>
          </template>
          <a-input-number
            v-model:value="formState.dailyLimit"
            class="threshold-limit-input"
            :min="1"
            :precision="0"
            :step="1"
            addon-after="$"
            placeholder="Please enter"
          />
        </a-form-item>

        <a-form-item
          label="Influencer Threshold"
          name="influencerThreshold"
        >
          <a-radio-group
            v-model:value="formState.influencerThreshold"
            name="influencerThreshold"
            @change="onInfluencerThresholdChange"
          >
            <a-radio :value="true">
              Yes
            </a-radio>
            <a-radio :value="false">
              No
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.influencerThreshold"
          label=" "
          :colon="false"
          :wrapper-col="{ span: 16 }"
        >
          <div class="influencer-threshold">
            <div class="influencer-threshold__toolbar">
              <a-button
                type="primary"
                @click="openInfluencerThresholdModal"
              >
                Add
              </a-button>
              <p class="subtitle influencer-threshold__tip">
                <ExclamationCircleOutlined style="margin-right: 5px;" />When Influencer Threshold is enabled, influencers in the list will be subject to this limit first.
              </p>
            </div>
            <a-table
              class="influencer-threshold__table"
              size="small"
              :pagination="false"
              :columns="influencerThresholdColumns"
              :data-source="formState.influencerThresholdList"
              row-key="influencerId"
            >
              <template #bodyCell="{ column, record, index }">
                <template v-if="column.key === 'dailyLimit'">
                  {{ formatLimitAmount(record.dailyLimit) }}
                </template>
                <template v-else-if="column.key === 'monthlyLimit'">
                  {{ formatLimitAmount(record.monthlyLimit) }}
                </template>
                <template v-else-if="column.key === 'operation'">
                  <a-popconfirm
                    title="Are you sure you want to delete this influencer threshold?"
                    ok-text="Confirm"
                    cancel-text="Cancel"
                    @confirm="removeInfluencerThreshold(index)"
                  >
                    <a href="javascript:;">Delete</a>
                  </a-popconfirm>
                </template>
              </template>
            </a-table>
          </div>
        </a-form-item>

        <a-form-item
          label="Advertiser Note"
          name="note"
        >
          <a-textarea
            v-model:value="formState.note"
            :rows="4"
            placeholder="please enter"
            maxlength="1000"
            show-count
          />
        </a-form-item>
        <a-form-item
          :wrapper-col="{ offset: 5, span: 16 }"
          style="margin-top: 20px"
        >
          <!-- <a-button
            style="margin-left: 10px"
            type="primary"
            html-type="submit"
            @click.prevent="onSubmitToBack"
            >{{ id ? 'Update' : 'Save' }} and Next</a-button
          > -->
          <a-button
            type="primary"
            html-type="submit"
          >
            {{
              id ? 'Update' : 'Save'
            }} and Next
          </a-button>
          <!-- <a-popconfirm
            title="Are you sure you want to cancel the new creation?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="router.replace('/advertisers')"
            @cancel="cancel"
          >
            <a-button style="margin-left: 10px" html-type="submit"
              >Cancel</a-button
            >
          </a-popconfirm> -->
          <a-button
            style="margin-left: 10px"
            @click="onCancel"
          >
            Cancel
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-alert
      v-if="errorMsg.error"
      style="position: fixed;right: 30px;bottom: 30px;"
      :message="errorMsg.error"
      type="error"
      show-icon
      closable
      :after-close="() => errorMsg = {}"
    >
      <template #description>
        <div>
          <p style="line-height: 1.5;">
            Advertisers Name : {{ errorMsg.advertiserName }}
            <br>Advertisers Id : {{ errorMsg.id }}
            <br>Domain : {{ errorMsg.domain }}
            <br>Path : {{ errorMsg.path }}
          </p>
        </div>
      </template>
    </a-alert>
    <a-modal
      title="Upload via URL"
      :open="showUrlPasteModal"
      :confirm-loading="loading"
      @ok="uploadImg"
      @cancel="showUrlPasteModal = false"
    >
      <a-textarea
        v-model:value="uploadImageUrl"
        placeholder="Please enter the image URL"
        allow-clear
      />
    </a-modal>

    <a-modal
      title="Add Influencer Threshold"
      :open="influencerThresholdModalOpen"
      :confirm-loading="influencerThresholdModalSaving"
      ok-text="OK"
      destroy-on-close
      @ok="submitInfluencerThresholdModal"
      @cancel="closeInfluencerThresholdModal"
    >
      <a-form
        ref="influencerThresholdFormRef"
        layout="vertical"
        :model="influencerThresholdForm"
      >
        <a-form-item
          label="Influencer"
          name="influencer"
          :rules="[{ required: true, message: 'Please select influencer', trigger: 'change' }]"
        >
          <a-select
            v-model:value="influencerThresholdForm.influencer"
            show-search
            label-in-value
            placeholder="Please enter"
            :filter-option="false"
            :not-found-content="thresholdKol.fetching ? undefined : null"
            :options="thresholdKol.data"
            @search="searchThresholdKol"
          >
            <template
              v-if="thresholdKol.fetching"
              #notFoundContent
            >
              <a-spin size="small" />
            </template>
          </a-select>
        </a-form-item>
        <a-form-item
          label="Daily Limit"
          name="dailyLimit"
          :rules="[{ required: false, validator: validateInfluencerDailyLimit, trigger: 'change' }]"
        >
          <a-input-number
            v-model:value="influencerThresholdForm.dailyLimit"
            :min="1"
            :precision="0"
            :step="1"
            addon-after="$"
            placeholder="Please enter"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item
          label="Monthly Limit"
          name="monthlyLimit"
          :rules="[{ required: true, validator: validateInfluencerMonthlyLimit, trigger: 'change' }]"
        >
          <a-input-number
            v-model:value="influencerThresholdForm.monthlyLimit"
            :min="1"
            :precision="0"
            :step="1"
            addon-after="$"
            placeholder="Please enter"
            style="width: 100%"
            @change="onInfluencerMonthlyLimitChange"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, reactive, toRaw, isProxy, createVNode, computed } from 'vue'
import { debounce } from 'lodash-es'
import { message, Modal } from 'ant-design-vue'
import { advertiser } from '../../server/index'
import { useRoute, useRouter } from 'vue-router'
import {
  LoadingOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons-vue'
import { isEqual, cloneDeep } from 'lodash';

const categoryList = ref([])
const assignedAmImList = ref([])
const regionList = ref([])
const route = useRoute()
const router = useRouter()

const errorMsg = ref({});

const id = route.params.id

const formRef = ref(null)

const formState = reactive({
  advertiserName: '',
  featuredMerchants: false,
  logo: '',
  mid: '',
  domain: '',
  path: '',
  regionId: null,
  displayStatus: 'active',
  categoryId: null,
  kolRule: false,
  kolRuleMode: null,
  merchantThreshold: false,
  monthlyLimit: null,
  dailyLimit: null,
  influencerThreshold: false,
  influencerThresholdList: [],
  assignedImId: 10,
  assignedAmId:5,
  note: '',
  kolWhiteListIds: [],
  kolBlackListIds: [],
})
const settings = ref(null)

const fileList = ref([])
const loading = ref(false)

const uploadImageUrl = ref('')
const showUrlPasteModal = ref(false)
const influencerThresholdModalOpen = ref(false)
const influencerThresholdModalSaving = ref(false)
const influencerThresholdFormRef = ref(null)
const influencerThresholdForm = reactive({
  influencer: null,
  dailyLimit: null,
  monthlyLimit: null,
})
const thresholdKol = reactive({
  data: [],
  fetching: false,
})
const influencerThresholdColumns = [
  { title: 'Influencer', dataIndex: 'influencerName', key: 'influencerName' },
  { title: 'DailyLimit', dataIndex: 'dailyLimit', key: 'dailyLimit' },
  { title: 'MonthlyLimit', dataIndex: 'monthlyLimit', key: 'monthlyLimit' },
  { title: 'Operation', key: 'operation', width: 100 },
]

let oldData = {
  advertiserName: '',
  featuredMerchants: false,
  logo: '',
  mid: '',
  domain: '',
  path: '',
  regionId: null,
  displayStatus: 'active',
  categoryId: null,
  kolRule: false,
  kolRuleMode: null,
  merchantThreshold: false,
  monthlyLimit: null,
  dailyLimit: null,
  influencerThreshold: false,
  influencerThresholdList: [],
  assignedImId: 10,
  assignedAmId:5,
  note: '',
  kolWhiteListIds: [],
  kolBlackListIds: [],
}

/** 当前 RuleMode 对应的名单，切换模式互不影响、各自保留 */
const currentKolListIds = computed({
  get() {
    return formState.kolRuleMode === 'blacklist'
      ? formState.kolBlackListIds
      : formState.kolWhiteListIds
  },
  set(val) {
    if (formState.kolRuleMode === 'blacklist') {
      formState.kolBlackListIds = val
    } else {
      formState.kolWhiteListIds = val
    }
  },
})

function onKolRuleChange() {
  if (!formState.kolRule) {
    formState.kolRuleMode = null
    formRef.value?.clearValidate(['kolRuleMode', 'kolWhiteListIds', 'kolBlackListIds'])
  } else {
    formState.kolRuleMode = null
  }
}

function onMerchantThresholdChange() {
  if (!formState.merchantThreshold) {
    formState.monthlyLimit = null
    formState.dailyLimit = null
    formRef.value?.clearValidate(['monthlyLimit', 'dailyLimit'])
  }
}

function onInfluencerThresholdChange() {
  if (!formState.influencerThreshold) {
    formState.influencerThresholdList = []
    closeInfluencerThresholdModal()
  }
}

function formatLimitAmount(value) {
  if (value == null || value === '') return '-'
  const num = Number(value)
  if (Number.isNaN(num)) return String(value)
  return `$ ${num.toFixed(2)}`
}

function resetInfluencerThresholdForm() {
  influencerThresholdForm.influencer = null
  influencerThresholdForm.dailyLimit = null
  influencerThresholdForm.monthlyLimit = null
  thresholdKol.data = []
  thresholdKol.fetching = false
}

function openInfluencerThresholdModal() {
  resetInfluencerThresholdForm()
  influencerThresholdModalOpen.value = true
}

function closeInfluencerThresholdModal() {
  influencerThresholdModalOpen.value = false
  influencerThresholdModalSaving.value = false
  resetInfluencerThresholdForm()
}

function validateInfluencerLimitValue(value, merchantLimit, label) {
  if (value == null || value === '') {
    return Promise.reject(`Please enter ${label}.`)
  }
  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return Promise.reject(`Please enter a positive integer for ${label}.`)
  }
  if (
    formState.merchantThreshold &&
    merchantLimit != null &&
    Number(value) > Number(merchantLimit)
  ) {
    return Promise.reject(
      `${label} cannot exceed Merchant ${label} ($${merchantLimit}).`
    )
  }
  return Promise.resolve()
}

const validateInfluencerDailyLimit = async (_rule, value) => {
  // Daily Limit 非必填
  if (value == null || value === '') return Promise.resolve()
  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return Promise.reject('Please enter a positive integer for Daily Limit.')
  }
  if (
    formState.merchantThreshold &&
    formState.dailyLimit != null &&
    Number(value) > Number(formState.dailyLimit)
  ) {
    return Promise.reject(
      `Daily Limit cannot exceed Merchant Daily Limit ($${formState.dailyLimit}).`
    )
  }
  const monthlyLimit = influencerThresholdForm.monthlyLimit
  if (
    monthlyLimit != null &&
    monthlyLimit !== '' &&
    Number(value) > Number(monthlyLimit)
  ) {
    return Promise.reject('Daily limit can not exceed monthly limit.')
  }
  return Promise.resolve()
}

const validateInfluencerMonthlyLimit = async (_rule, value) => {
  await validateInfluencerLimitValue(value, formState.monthlyLimit, 'Monthly Limit')
  const dailyLimit = influencerThresholdForm.dailyLimit
  if (
    dailyLimit != null &&
    dailyLimit !== '' &&
    Number(dailyLimit) > Number(value)
  ) {
    return Promise.reject('Daily limit can not exceed monthly limit.')
  }
  return Promise.resolve()
}

function onInfluencerMonthlyLimitChange() {
  // 在校验器外触发，避免 validate() 出现 outOfDate
  Promise.resolve().then(() => {
    influencerThresholdFormRef.value?.validateFields(['dailyLimit']).catch(() => {})
  })
}

async function submitInfluencerThresholdModal() {
  try {
    await influencerThresholdFormRef.value?.validate()
  } catch (e) {
    // outOfDate 且无字段错误时视为通过（避免嵌套校验误杀）
    if (!e?.errorFields?.length && e?.outOfDate) {
      // continue
    } else {
      return Promise.reject(e)
    }
  }

  const influencer = influencerThresholdForm.influencer
  const influencerId = influencer?.value
  if (
    formState.influencerThresholdList.some(
      (item) => String(item.influencerId) === String(influencerId)
    )
  ) {
    message.error('This influencer is already in the list.')
    return Promise.reject(new Error('duplicate'))
  }

  formState.influencerThresholdList.push({
    influencerId,
    influencerName: influencer?.label || String(influencerId),
    dailyLimit:
      influencerThresholdForm.dailyLimit == null || influencerThresholdForm.dailyLimit === ''
        ? null
        : Number(influencerThresholdForm.dailyLimit),
    monthlyLimit: Number(influencerThresholdForm.monthlyLimit),
  })
  closeInfluencerThresholdModal()
}

function removeInfluencerThreshold(index) {
  formState.influencerThresholdList.splice(index, 1)
}

const searchThresholdKol = debounce((keyword) => {
  thresholdKol.data = []
  thresholdKol.fetching = true
  advertiser.getKolWhiteList(keyword).then((res) => {
    thresholdKol.fetching = false
    if (res.success) {
      thresholdKol.data = (res.data || []).map((item) => ({
        label: item.userName,
        value: item.id,
      }))
    } else {
      message.error('Failed to search influencer, please try again.')
    }
  })
}, 300)

function onRuleModeChange() {
  kol.data = []
  formRef.value?.clearValidate(['kolWhiteListIds', 'kolBlackListIds'])
}

// KOL白名单
const kol = reactive({
  data: [],
  fetching: false,
})

const rules = {
  affiliateId: [{ required: true, message: 'Please select affiliate', trigger: 'change' }],
  domain: [{ required: true, message: 'Please input domain', trigger: 'change' }],
  assignedAmId: [{ required: true, message: 'Please select assignedAm', trigger: 'change' }],
  categoryId: [{ required: true, message: 'Please select category', trigger: 'change' }],
  mid: [{ required: true, message: 'Please input mid', trigger: 'change' }],
  regionId: [{ required: true, message: 'Please select region', trigger: 'change' }],
};

const validateRuleMode = async (_rule, value) => {
  if (!formState.kolRule) return Promise.resolve()
  if (value === 'whitelist' || value === 'blacklist') return Promise.resolve()
  return Promise.reject('Please select RuleMode.')
}

const ruleModeRules = [
  {
    required: true,
    validator: validateRuleMode,
    trigger: 'change',
  },
]

const validateRuleList = async (_rule, value) => {
  if (!formState.kolRule) return Promise.resolve()
  if (Array.isArray(value) && value.length > 0) return Promise.resolve()
  return Promise.reject('Please fill in at least one infuluencer in RuleList.')
}

const ruleListRules = [
  {
    required: true,
    validator: validateRuleList,
    trigger: 'change',
  },
]

const validateMerchantLimit = async (_rule, value) => {
  if (!formState.merchantThreshold) return Promise.resolve()
  if (value == null || value === '') {
    return Promise.reject('Please enter a positive integer.')
  }
  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return Promise.reject('Please enter a positive integer.')
  }
  return Promise.resolve()
}

const validateMerchantDailyLimit = async (_rule, value) => {
  if (!formState.merchantThreshold) return Promise.resolve()
  // Daily Limit 非必填
  if (value == null || value === '') return Promise.resolve()
  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return Promise.reject('Please enter a positive integer.')
  }
  if (
    formState.monthlyLimit != null &&
    formState.monthlyLimit !== '' &&
    Number(value) > Number(formState.monthlyLimit)
  ) {
    return Promise.reject('Daily limit can not exceed monthly limit.')
  }
  return Promise.resolve()
}

const validateMerchantMonthlyLimit = async (_rule, value) => {
  await validateMerchantLimit(_rule, value)
  if (
    formState.dailyLimit != null &&
    formState.dailyLimit !== '' &&
    Number(formState.dailyLimit) > Number(value)
  ) {
    return Promise.reject('Daily limit can not exceed monthly limit.')
  }
  return Promise.resolve()
}

function onMerchantMonthlyLimitChange() {
  Promise.resolve().then(() => {
    formRef.value?.validateFields(['dailyLimit']).catch(() => {})
  })
}

const merchantDailyLimitRules = [
  {
    required: false,
    validator: validateMerchantDailyLimit,
    trigger: 'change',
  },
]

const merchantMonthlyLimitRules = [
  {
    required: true,
    validator: validateMerchantMonthlyLimit,
    trigger: 'change',
  },
]

const hasDataChanged = () => {
  return isEqual(toRaw(formState), oldData);
}

const onCancel = () => {
  if (!hasDataChanged()) {
        Modal.confirm({
            title: 'Confirm',
            icon: createVNode(ExclamationCircleOutlined),
            content: `Are you sure you want to cancel ${id ? 'these changes' : 'the new creation' }?`,
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: () => {
              router.go(-1)
            }
        });
    } else {
      router.go(-1)
    }
}

const init = () => {
  advertiser.getSettingsInfo().then((res) => {
    settings.value = res.data
  })
  if (id) {
    advertiser.getDetail(id).then((res) => {
      if (res.success) {
        const mapKolList = (list) =>
          (list || []).map((item) => ({
            label: item.name,
            value: item.id,
          }))
        res.data.kolWhiteListIds = mapKolList(res.data.kolWhiteList)
        res.data.kolBlackListIds = mapKolList(res.data.kolBlackList)
        res.data.kolRuleMode = res.data.kolRuleMode || res.data.ruleMode || null
        if (res.data.kolRuleMode) {
          res.data.kolRuleMode = String(res.data.kolRuleMode).toLowerCase()
        }
        if (!res.data.kolRule) {
          res.data.kolRuleMode = null
        }
        const salesThreshold = res.data.salesThreshold || {}
        res.data.merchantThreshold = !!salesThreshold.scopeEnabled
        res.data.dailyLimit = salesThreshold.dailyLimit ?? null
        res.data.monthlyLimit = salesThreshold.monthlyLimit ?? null
        res.data.influencerThreshold = !!salesThreshold.influencerEnabled
        res.data.influencerThresholdList = (salesThreshold.items || []).map((item) => ({
          influencerId: item.influencerId ?? item.id,
          influencerName:
            item.influencerName || item.userName || item.name || String(item.influencerId ?? item.id),
          dailyLimit: item.dailyLimit,
          monthlyLimit: item.monthlyLimit,
        }))
        if (!res.data.merchantThreshold) {
          res.data.dailyLimit = null
          res.data.monthlyLimit = null
        }
        if (!res.data.influencerThreshold) {
          res.data.influencerThresholdList = []
        }
        delete res.data.kolWhiteList
        delete res.data.kolBlackList
        delete res.data.ruleMode
        delete res.data.salesThreshold
        Object.assign(formState, res.data)
        oldData = cloneDeep(toRaw(formState));
      }
    })
  }
}

function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG file!')
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!')
  }
  return isJpgOrPng && isLt2M
}

const handleChange = (info) => {
  if (info.file.status === 'uploading') {
    loading.value = true
    return
  }
  if (info.file.status === 'done') {
    // Get this url from response in real world.
    getBase64(info.file.originFileObj, (base64Url) => {
      formState.logo = base64Url
      loading.value = false
    })
  }
  if (info.file.status === 'error') {
    loading.value = false
    message.error('upload error')
  }
}

const uploadImg = (e) => {
  const data = {};

  if (e.file) {
    data.file = e.file
  } else {
    loading.value = true
    data.url = encodeURIComponent(uploadImageUrl.value)
  }
  advertiser.uploadImg(data).then((res) => {
    loading.value = false
    
    if (res.success) {
      formState.logo = res.data.url
      
      if (data.url) {
        showUrlPasteModal.value = false
      }
    } else {
      message.error('Upload failed, please try again.')
    }
  }).catch(e => {
    console.log(e)
  })
}

const onFinish = (values) => {
  if (id) {
    values.id = id
  }
  const mapIds = (list) => {
    const raw = isProxy(list) ? toRaw(list) : list
    return raw?.map((item) => item.value) || []
  }
  if (values.kolRuleMode === 'blacklist') {
    values.kolBlackListIds = mapIds(formState.kolBlackListIds)
    values.kolWhiteListIds = []
  } else {
    values.kolWhiteListIds = mapIds(formState.kolWhiteListIds)
    values.kolBlackListIds = []
  }
  const scopeEnabled = !!formState.merchantThreshold
  const influencerEnabled = !!formState.influencerThreshold
  values.salesThreshold = {
    scopeEnabled,
    dailyLimit: scopeEnabled ? formState.dailyLimit : null,
    monthlyLimit: scopeEnabled ? formState.monthlyLimit : null,
    influencerEnabled,
    items: influencerEnabled
      ? toRaw(formState.influencerThresholdList).map((item) => ({
          influencerId: item.influencerId,
          dailyLimit: item.dailyLimit,
          monthlyLimit: item.monthlyLimit,
        }))
      : [],
  }
  delete values.merchantThreshold
  delete values.dailyLimit
  delete values.monthlyLimit
  delete values.influencerThreshold
  delete values.influencerThresholdList
  console.log(values)
  advertiser.addAdvertiser(values).then((res) => {
    if (res.success) {
      message.info('Advertiser info save success!')
      router.replace(`/affiliate/edit/${res.data.id}`);
    } else {
      if (res.code === '200') {
        res.data.error = res.error;
        errorMsg.value = res.data;
      } else {
        message.error(res.error)
      }
    }
  })
}

const fetchData = async (
  action = 'getAffiliateList',
  varName,
  errorKey = 'affiliate'
) => {
  const res = await advertiser[action]()

  if (res.success) {
    varName.value = res.data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      }
    })
  } else {
    message.error(
      `获取${errorKey}列表失败, 页aaaa面将会在3秒后返回到Advertiser列表页面。`
    )
  }
}
fetchData('getCategoryList', categoryList, 'category')
fetchData('getAssignedAMIMList', assignedAmImList, 'assignedAm/Im')
fetchData('getRegionList', regionList, 'region')
const searchKolWhiteList = debounce((keyword) => {
  kol.data = []
  kol.fetching = true
  advertiser.getKolWhiteList(keyword).then((res) => {
    kol.fetching = false
    if (res.success) {
      kol.data = res.data.map((item) => {
        return {
          label: item.userName,
          value: item.id,
        }
      })
    } else {
      message.error('获取KOL白名单失败，请重试')
    }
  })
}, 300)

init()
</script>

<style lang="less" scoped>
.content {
  padding: 20px 60px;
  margin-bottom: 20px;
  .max-w {
    max-width: 320px;
  }
}
.commissions-list {
  background-color: #eee;
  border-radius: 10px;
  padding: 20px;
  width: 600px;
  margin-top: 20px;
}
.avatar {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
.logo-uploader {
  display: flex;
  align-items: flex-end;
  .logo-placeholder {
    width: 102px;
    height: 102px;
    overflow: hidden;
    position: relative;
    text-align: center;
    line-height: 102px;
    margin-right: 10px;
    border-radius: 8px;
    border: 1px dashed #d9d9d9;
    background: rgba(0, 0, 0, 0.02);
    :deep(.anticon-loading) {
      top: 41px;
      left: 41px;
      position: absolute;
    }
    &.uploaded {
      border: none;
    }
  }
}
.avatar-uploader {
  :deep(.ant-upload-select) {
    cursor: pointer;
    color: #1677ff;
    width: auto !important;
    height: auto !important;
    border: none !important;
    background: transparent !important;
    &:hover{
      color: #69b1ff;
    }
  }
}
.subtitle {
  margin-top: 3px;
  color: #999;
  margin-bottom: 0;
}
.threshold-limit-input {
  width: 320px;
}
.influencer-threshold {
  width: 100%;
  max-width: 960px;
}
.influencer-threshold__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.influencer-threshold__tip {
  margin: 0;
}
.influencer-threshold__table {
  :deep(.ant-table) {
    background: #fff;
  }
}
</style>
